module.exports = __webpack_public_path__ + "static/media/Jack Daniels Logo.251d73f6.svg";